const LS_ROTATE_KEY = 'history-files-rotate'
const LS_FLIP_KEY = 'history-files-flip'

export const isPdfUrl = (url: string): boolean => {
  if (!url) return false
  try {
    return new URL(url).pathname.toLowerCase().endsWith('.pdf')
  } catch {
    return /\.pdf(\?|#|$)/i.test(url)
  }
}

export const isHeicUrl = (url: string): boolean => {
  if (!url) return false
  try {
    const pathname = new URL(url).pathname.toLowerCase()
    return pathname.endsWith('.heic') || pathname.endsWith('.heif')
  } catch {
    return /\.(heic|heif)(\?|#|$)/i.test(url)
  }
}

const getRotateKey = (historyId: string, src: string, page?: number) => {
  let filename = src
  try {
    const pathname = new URL(src).pathname
    filename = pathname.split('/').pop() || pathname
  } catch {
    // relative src: fall back to the raw src as the key (mirrors isPdfUrl)
  }
  const base = `${historyId}:${filename}`
  return page == null ? base : `${base}#${page}`
}

const getRotations = (): Record<string, number> => {
  try {
    return JSON.parse(localStorage.getItem(LS_ROTATE_KEY) || '{}')
  } catch {
    return {}
  }
}

export const getSavedRotation = (historyId: string, src: string, page?: number) =>
  getRotations()[getRotateKey(historyId, src, page)] ?? 0

export const saveRotation = (
  historyId: string,
  src: string,
  rotate: number,
  page?: number,
) => {
  const key = getRotateKey(historyId, src, page)
  const data = getRotations()
  if (rotate === 0) {
    delete data[key]
  } else {
    data[key] = rotate
  }
  localStorage.setItem(LS_ROTATE_KEY, JSON.stringify(data))
}

export const getSavedFlip = (historyId: string, src: string, page?: number) => {
  const key = getRotateKey(historyId, src, page)
  try {
    return JSON.parse(localStorage.getItem(LS_FLIP_KEY) || '{}')[key] === true
  } catch {
    return false
  }
}

export const saveFlip = (
  historyId: string,
  src: string,
  flipped: boolean,
  page?: number,
) => {
  const key = getRotateKey(historyId, src, page)
  let data: Record<string, boolean> = {}
  try {
    data = JSON.parse(localStorage.getItem(LS_FLIP_KEY) || '{}')
  } catch {
    data = {}
  }
  if (flipped) data[key] = true
  else delete data[key]
  localStorage.setItem(LS_FLIP_KEY, JSON.stringify(data))
}
